module.exports = __webpack_public_path__ + "static/img/ToLeadInto.95bac5a0.png";